import React, { useState } from 'react';
import TopNav from '../../../Components/TopNav';
import Navbar from '../../../Components/Navbar';
import DropdownNav from '../../../Components/DropdownNav';
import './about.css'
import Footer from '../../../Components/Footer';
import Example from '../../../Components/Example';
import ScrollToTop from "react-scroll-to-top";

const Adminstration = () => {
  const [toggle, setToggle] = useState(1)
  const [isOpen, setIsOpen] = useState(false)
  const [joint, setJoint] = useState(false)
  const [hons, setHons] = useState(false)
  const [princpal, setPrincpal] = useState(false)
  const [fifth, setFifth] = useState(false)
  const [Sixth, setSixth] = useState(false)
  const [sev, setSev] = useState(false)
  const [eigth, setEigth] = useState(false)
  const [nine, setNine] = useState(false)
  const [tenth, setTenth] = useState(false)
  const [eleven, setEleven] = useState(false)
  const [tweal, setTweal] = useState(false)
  const [theten, setTheten] = useState(false)
  const [fourten, setFourten] = useState(false)
  const [fiftens, setFiftens] = useState(false)


  function updateToogle(id) {
    setToggle(id)
  }


  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='init-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      <div className='Measi-details'>
        <div className='measi-header'>
          <h2>Infrastructure → Administration</h2>
          <p>The New College infrastructure is one of the biggest & best in Tamil Nadu.</p>
        </div>

        <div className='tab-main'>
          <ul className='tab-details'>
            <li className={toggle === 1 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(1)}>Organogram</li>
            <li className={toggle === 2 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(2)}>Managing Committee</li>
            <li className={toggle === 3 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(3)}>Administrators</li>
            <li className={toggle === 4 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(4)}>Governance</li>
          </ul>


          {/* Tab One Details */}

          <div className={toggle === 1 ? "show-tab-content" : 'tab-content'}>
            <h1>COLLEGE CREST</h1>
            <div className='tab-para'>
              <div >
                <div className='ssr-items'>
                  {/* This is the starting node of AQARREPORTS */}
                  <div>
                    <div className='aqar-items'>
                      <a href='https://thenewcollege.edu.in/pdf/orgonogram-final.pdf' target='new'>
                        <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                        <h3>Organogram</h3>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second Tab Details */}

          <div className={toggle === 2 ? "show-tab-content" : 'tab-content'}>
            <h1>Managing Committee of THE NEW COLLEGE</h1>

            <h2>PRESIDENT</h2>
            <div className='tab-para'>
              <div className='tab-img'>
                <img src='https://thenewcollege.edu.in/images/chairman.jpg' style={{ width: "20%", height: "auto" }} />
                <p style={{ marginLeft: "10%" }}>Janab Imthiaz Pasha Sahib</p>
              </div>

              <h2>IMMEDIATE PAST PRESIDENT:</h2>
              <p>⬣ Nawab Mohammed Abdul Ali Azimjah</p>

              <h2>PATRONS:</h2>
              <p>⬣ Janab U. Mohamed Khalilullah Sahib</p>
              <p>⬣ Janab M. Mohamed Hashim Sahib</p>

              <h2>HONY. SECRETARY</h2>
              <div className='tab-img'>
                <img src='https://thenewcollege.edu.in/images/secretary.jpg' style={{ width: "20%", height: "auto" }} />
                <p style={{ marginLeft: "10%" }}>Janab Elias Sait Sahib</p>
              </div>

              <h2>Janab Elias Sait Sahib</h2>
              <div className='tab-img'>
                <img src='https://thenewcollege.edu.in/images/treasurer.jpg' style={{ width: "20%", height: "auto" }} />
                <p style={{ marginLeft: "10%" }}>Janab. S.M.A. Mohammed Saleem Sahib</p>
              </div>

              <h2>HONY. ASST. SECRETARIES:</h2>
              <p>⬣ Janab A. Imtiaz Ahmed Sahib</p>
              <p>⬣ Janab S.K. Nawaz Sahib</p>
              <p>⬣ Janab M. Nazar Mohamed Sahib</p>
              <p>⬣ Janab M. Muniruddin Sheriff Sahib</p>
              <p>⬣ Janab S.K. Sham Shahabuddin Sahib</p>
              <p>⬣ Janab Ashfaque Ahmed Mecca Sahib</p>

              <h2>HONY. ASST. TREASURER:</h2>
              <p>⬣ Janab Sajid Sathak Sahib</p>

              <h2>MEMBERS:</h2>
              <p>⬣ Janab M. Razzack Sahib</p>
              <p>⬣ Janab A. Mohamed Ashraf Sahib</p>
              <p>⬣ Janab H.M. Shamsudeen Sahib</p>
              <p>⬣ Janab Abdul Jabbar Suhail Sahib</p>
              <p>⬣ Janab J. Anver Salman Sahib</p>

              <h2>PRINCIPAL (EX. OFFICIO):</h2>
              <p>⬣ Dr. M. Asrar Sheriff</p>

            </div>
          </div>

          {/* Third Tab Details */}

          <div className={toggle === 3 ? "show-tab-content" : 'tab-content'}>
            <h1>Administration</h1>
            <button onClick={() => setIsOpen(e => !e)} className='tab-open-btn'>✠ Principal & Warden  </button>
            {
              isOpen && (
                <div >
                  <h2>Principal & Warden and Nodal Officer</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/principal.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. M. Asrar Sheriff</h2>
                        <p>M.Sc., M.Phil., Ph.D.,</p>
                        <p>Email: principal@thenewcollege.edu.in</p>
                      </div>
                    </div>
                    <p>⬣ It gives me immense pleasure to welcome all the students of Under - graduate and Post - graduate and research streams to this premier institution. Our college, enjoying total autonomous status for the last several years, has recently been upgraded and placed at ‘A++’ grade by the National Assessment and Accreditation council (NAAC), thanks to the staff and the students for these achievements.</p>
                    <p>⬣ Located in the heart of the city, The New College is the cynosure of all eyes. The infrastructure that the college has is second to none. There is no force more paralyzing then the fear of failure. To overcome this, we mould our students to be self confident and pragmatic such that when they enter life after their studies, they are empowered to face various challenges with coverage, conventions and success. What do we expect from our students in return? They must be regular and punctual to their classes. They should respect their parents and teachers.</p>
                    <p>⬣ Honesty and discipline should be their watchwords. Concentration on studies and systematic preparation will ensure academic excellence. Taking part in sports, co-curricular and extra-curricular activities will make the students more competitive. Campus interviews by reputed firms leading to placement are regularly held for the outgoing students every year.</p>
                    <p>
                      ⬣ The students must exhibit exemplary behavior even outside the college without getting themselves provoked or letting themselves be taken for a ride especially while travelling. Directly or indirectly, knowingly or unknowingly, they should in no way bring disrepute to the college of their study. I am sure our students will always strive to uphold the dignity of our college and keeps its flag ever flying high. India is known for its rich values, culture and heritage. I impress upon all our young learning community to emerge as her proud and worthy citizens.</p>
                    <p>
                      ⬣ I wish our students success in all their endeavours.</p>
                    <div className='prins'>
                      <p>Dr. M. Asrar Sheriff <br></br>
                        Principal</p>
                    </div>
                  </div>


                </div>
              )
            }


            <button onClick={() => setJoint(e => !e)} className='tab-open-btn'>✠ Vice Principal (Administration) </button>
            {
              joint && (
                <div >
                  <h2>Vice Principal (Administration)</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/vpad1.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. P.A. Abdullah Mahaboob</h2>
                        <p>M.Sc., B.Ed., Ph.D.,</p>
                        <p>Vice Principal (Administration)</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }

            <button onClick={() => setHons(e => !e)} className='tab-open-btn'>✠ Vice Principal (Academic) </button>
            {
              hons && (
                <div >
                  <h2>Vice Principal (Academic)</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/T.K.%20Shabeer.jfif' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. T.K. Shabeer</h2>
                        <p>M.Sc., Ph.D</p>
                        <p>Vice Principal (Academic)</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }


            <button onClick={() => setPrincpal(e => !e)} className='tab-open-btn'>✠ Controller of Examinations </button>
            {
              princpal && (
                <div >
                  <h2>Controller of Examinations</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/Sarmadhsir.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Mr. A. Syed Sarmadh Ahmed</h2>
                        <p>M.A., M.Phil.,</p>
                        <p>Controller of Examinations</p>
                      </div>
                    </div>

                  </div>
                  <h2>Deputy Controller of Examinations</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/Naveed.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. Mohammed Ibrahim Naveed</h2>
                        <p>M.Sc., Ph.D.,</p>
                        <p>Deputy Controller of Examinations</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }

            <button onClick={() => setFifth(e => !e)} className='tab-open-btn'>✠ Director of IQAC </button>
            {
              fifth && (
                <div >
                  <h2>Director - Internal Quality Assurance Cell (IQAC)</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/ANWAR.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. Anvar Sadhath Valiyaparambath</h2>
                        <p>M.A., M.Phil., B.Ed., Ph.D., <br></br>
                          Director IQAC</p>
                        <p>iqac@thenewcollege.edu.in</p>
                        <p>Director - Internal Quality Assurance Cell (IQAC)</p>
                      </div>
                    </div>

                  </div>
                  <h2>IQAC Co-Ordinator</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/iqac-coordinator1.png' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. T. Abdul Khadar</h2>
                        <p>M.A., M.Phil., Ph.D., PGDTA, PGDHR. <br></br>
                          Co-Ordinator, IQAC</p>
                        <p>abdulkhadar@thenewcollege.edu.in</p>
                        <p>IQAC Co-Ordinator</p>
                      </div>
                    </div>
                  </div>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/iqac-coordinator2.png' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. Mohammed Ibrahim Naveed</h2>
                        <p>M.Sc., Ph.D. <br></br>
                          Co-Ordinator, IQAC</p>
                        <p>mohammedibrahimnaveed@thenewcollege.edu.in</p>
                        <p>IQAC Co-Ordinator</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }

            <button onClick={() => setSixth(e => !e)} className='tab-open-btn'>✠ Deputy Warden  </button>
            {
              Sixth && (
                <div >
                  <h2>Deputy Warden</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/ACOE%20-%20HYDER%20ALI.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. A. Hyder Ali</h2>
                        <p>M.Sc., M.Phil., Ph.D.,</p>
                        <p>Deputy Warden</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }

          </div>

          {/* Fourth Tab Details */}

          <div className={toggle === 4 ? "show-tab-content" : 'tab-content'}>
            <h1>Governance</h1>
            <button onClick={() => setIsOpen(e => !e)} className='tab-open-btn'>✠ Dean - School of Language and Literature  </button>
            {
              isOpen && (
                <div >
                  <h2>Dean - School of Language and Literature </h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/dean-arts.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. N.M. Ahamed Ibrahim</h2>
                        <p>Dean - School of Language and Literature</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }


            <button onClick={() => setJoint(e => !e)} className='tab-open-btn'>✠ Dean - School of Physical and Chemical Sciences </button>
            {
              joint && (
                <div >
                  <h2>Dean - School of Physical and Chemical Sciences</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/Rasheeth.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Dr. A. Rasheeth</h2>
                        <p>Dean - School of Physical and Chemical Sciences</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }

            <button onClick={() => setHons(e => !e)} className='tab-open-btn'>✠ Dean - School of Commerce and Management </button>
            {
              hons && (
                <div >
                  <h2>Dean - School of Commerce and Management</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/dean-commerce.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Dr. Syed Abdul Hameed</h2>
                        <p>Dean - School of Commerce and Management</p>
                      </div>
                    </div>

                  </div>


                </div>
              )
            }


            <button onClick={() => setPrincpal(e => !e)} className='tab-open-btn'>✠ Dean of Computational Science </button>
            {
              princpal && (
                <div >
                  <h2>Dean of Computational Science</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/dean-comp.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Prof. A. R. Abdul Lathif</h2>
                        <p>Dean of Computational Science</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setFifth(e => !e)} className='tab-open-btn'>✠ Dean of Biological Science </button>
            {
              fifth && (
                <div >
                  <h2>Dean of Biological Science</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/sultan-mohideen.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Dr. A.K. Sultan Mohideen</h2>
                        <p>Dean of Biological Science</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setSixth(e => !e)} className='tab-open-btn'>✠ Dean of Student's Affairs  </button>
            {
              Sixth && (
                <div >
                  <h2>Dean of Student's Affairs</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/dean-stud.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Prof. A. Khaja Mohideen</h2>
                        <p>Dean of Student's Affairs</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }


            <button onClick={() => setSev(e => !e)} className='tab-open-btn'>✠ Dean of Research </button>
            {
              sev && (
                <div >
                  <h2>Dean of Research</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/dean-research.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. M. Gulam Mohamed</h2>
                        <p>Dean of Research</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }


            <button onClick={() => setNine(e => !e)} className='tab-open-btn'>✠ Bursar  </button>
            {
              nine && (
                <div >
                  <h2>Bursar</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/bursar.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Mr. D. Burhanuddin Dulvi</h2>
                        <p>Bursar</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setTenth(e => !e)} className='tab-open-btn'>✠ Assistant Controller of Examinations  </button>
            {
              tenth && (
                <div >
                  <h2>Assistant Controller of Examinations</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/Yunus.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Dr. A. Mohamed Yunus</h2>
                        <p>Assistant Controller of Examinations</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setEleven(e => !e)} className='tab-open-btn'>✠ Placement Officer </button>
            {
              eleven && (
                <div >
                  <h2>Placement Officer</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/ansarm.png' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Dr. M. Ansar</h2>
                        <p>M.C.S., M.Phil., M.Com., M.Phil., P.G.D.B.M.,</p>
                        <p>Placement Officer</p>
                        <p>placement@thenewcollege.edu.in</p>
                      </div>
                    </div>
                  </div>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/Yahiya.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. Z. Mohammed Yahiya</h2>
                        <p>M.Com., M.Phil., Ph.D.,</p>
                        <p>Assistant Placement Officer</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setTweal(e => !e)} className='tab-open-btn'>✠ Coordinator, Projects and Grants  </button>
            {
              tweal && (
                <div >
                  <h2>Coordinator, Projects and Grants</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/ucg-grants-coordinator.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2>Dr. Mohammed Ibrahim Naveed</h2>
                        <p>M.Sc., Ph.D.,</p>
                        <p>Coordinator, Projects and Grants</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setTheten(e => !e)} className='tab-open-btn'>✠ Director Of IIEC  </button>
            {
              theten && (
                <div >
                  <h2>Director Of IIEC</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/MNM_Photo.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Dr. M. Nizam Mohideen</h2>
                        <p>M.Sc., P.G.D.C.A., M.Phil., Ph.D.,</p>
                        <p>Director Of IIEC</p>
                        <p>iiec@thenewcollege.edu.in</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }


            <button onClick={() => setFourten(e => !e)} className='tab-open-btn'>✠ Director New College Social Service (NCSS)  </button>
            {
              fourten && (
                <div >
                  <h2>Director New College Social Service (NCSS)</h2>
                  <div className='tab-para'>
                    <div className='tab-img'>
                      <img src='https://thenewcollege.edu.in/images/director-ncss.jpg' style={{ width: "20%", height: "auto", borderRadius: "20px" }} className='ward-img' />
                      <div className='admin-tab-card'>
                        <h2> Dr. J. Sulaiman</h2>
                        <p>M.Com., M.Phil., Ph.D., M.A (PA)., M.B.A., PGDFT.,</p>
                        <p>Director New College Social Service (NCSS)</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }


          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Adminstration;
